"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BBAuthDomain = void 0;
var thirdPartyDomainSTSUrlMappings = {
    'bbk12.com': 'https://sts-sso.bbk12.com',
    'blackbaud.school': 'https://account.blackbaud.school',
    'blackbaud.school.mirror.d04.io': 'https://account.blackbaud.school.mirror.d04.io',
    'blackbaud.school.stage.d04.io': 'https://account.blackbaud.school.stage.d04.io',
    'blackbaudfaith.com': 'https://sts.blackbaudfaith.com',
    'blackbaudhosting.com': 'https://sts.blackbaudhosting.com',
    'blackbaudportal.com': 'https://sts.blackbaudportal.com',
    'donorcentral.com': 'https://sts-dc.donorcentral.com',
    'etapestry.com': 'https://sts.etapestry.com',
    'justgiving.com': 'https://id.justgiving.com',
    'mycampus-app.com': 'https://sts-sso.mycampus-app.com',
    'myschoolapp.com': 'https://sts-sso.myschoolapp.com',
    'myschoolautomation.com': 'https://sts-sso.myschoolautomation.com',
    'myschooldemo.com': 'https://sts-sso.myschooldemo.com',
    'myschooltraining.com': 'https://sts-sso.myschooltraining.com',
    'smartaidforparents-com-stage.smarttuition.net': 'https://account.smartaidforparents-com-stage.smarttuition.net',
    'smartaidforparents.com': 'https://account.smartaidforparents.com',
    'smarttuition.com': 'https://account.smarttuition.com',
    'yourcausegrants.com': 'https://sts.yourcausegrants.com',
    'yourcausegrantsqa.com': 'https://sts.yourcausegrantsqa.com',
    'yourcausegrantsuat.com': 'https://sts.yourcausegrantsuat.com'
};
var defaultSTSUrl = 'https://sts.sky.blackbaud.com';
var BBAuthDomain = /** @class */ (function () {
    function BBAuthDomain() {
    }
    BBAuthDomain.getRegisteredDomain = function () {
        for (var _i = 0, _a = Object.keys(thirdPartyDomainSTSUrlMappings); _i < _a.length; _i++) {
            var d = _a[_i];
            var domainEndCompare = ".".concat(d);
            if (this.CURRENT_DOMAIN === d ||
                this.CURRENT_DOMAIN.substr(-domainEndCompare.length) ===
                    domainEndCompare) {
                return d;
            }
        }
    };
    BBAuthDomain.getSTSDomain = function () {
        var registeredDomain = this.getRegisteredDomain();
        return thirdPartyDomainSTSUrlMappings[registeredDomain] || defaultSTSUrl;
    };
    BBAuthDomain.CURRENT_DOMAIN = window.location.hostname;
    return BBAuthDomain;
}());
exports.BBAuthDomain = BBAuthDomain;
